import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { isOwner } from 'entities';

import { Alert, Button, Column } from 'components/Blocks';

import { useUser } from 'hooks/user';
import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

export function InvoiceAlerts() {
  const user = useUser();

  const {
    project,
    loading,
    projectModalConfig: { openModal },
  } = useProjectProfile();

  const { t } = useLang();

  const alerts = useMemo(() => {
    if (!project) return [];

    return [
      {
        action: () => openModal('MANAGE_COSTS'),

        actionText: t('view'),

        text: t('your-repricing-request-has-been-answered'),

        render: [
          project?.reprice === 'PENDING_APPROVAL',
          isOwner(project.invoice, user),
          project.repriceOrigin === 'INVOICE',
        ].every(Boolean),
      },

      {
        text: t('reprice-currently-active-by-invoice'),

        render: [
          isOwner(project.invoice, user) ||
            (project.invoice.owner.team === user.team.id && user.type === 'LEADER'),
          project.repriceOrigin === 'INVOICE',
          project?.reprice !== 'PENDING_APPROVAL',
        ].every(Boolean),
      },
    ].filter(({ render }) => render);
  }, [openModal, project, t, user]);

  if (loading || !alerts.length) return null;

  return (
    <Column className="animate-in slide-in-from-bottom-12" alignItems="center">
      {alerts.map(({ action, actionText, text }) => (
        <Alert level="warning" key={text} bodyClassName="flex gap-2 items-center">
          {text}

          {!!action && (
            <Button
              className="ml-auto"
              color="warning"
              variant="ghost"
              size="small"
              onClick={action}
            >
              {actionText}
            </Button>
          )}
        </Alert>
      ))}
    </Column>
  );
}
